import {ExperienceType} from '@intellimize/customer';
import {TEMP_PATH} from '@packages/utilities/expression-path-constants';
import {
  ExpressionPath,
  getSystem,
  type Type,
  withSystem,
} from '@packages/systems/wfdl';

import {
  AIOptimizeIcon,
  IconComponent,
  OptimizationPersonalizeIcon,
  OptimizationTestIcon,
} from '@packages/systems/spring';
import {TBoolean, TList, TRecord, TText} from '@packages/systems/wfdl-ast';

export const OPTIMIZATION_LOGGER_META = {
  team: 'optimization',
  area: 'optimization',
} as const;

export const EXPERIENCE_TYPE_LABELS: Record<ExperienceType, string> = {
  ab: 'Test',
  rbp: 'Personalization',
  cc: 'AI optimize',
};

export const EXPERIENCE_TYPE_FOR_ANALYTICS: Record<ExperienceType, string> = {
  ab: 'traditional',
  rbp: 'manual',
  cc: 'ai-optimized',
};

export const ICON_BY_TYPE: Record<ExperienceType, IconComponent> = {
  cc: AIOptimizeIcon,
  rbp: OptimizationPersonalizeIcon,
  ab: OptimizationTestIcon,
};

export const MATCHING_VARIATION_ATOM_ID_PATH: ExpressionPath = [
  ...TEMP_PATH,
  {in: 'Record', at: 'matchingVariationAtomId'},
];

export const CLICK_GOAL_EVENT_IDS_PATH: ExpressionPath = [
  {in: 'Record', at: 'eventIds'},
];

/**
 * The hidden boolean prop a click goal adds to a component. The goal's
 * `eventIds` entry is bound to it.
 */
export const createClickGoalTrackingField = (defaultValue: boolean) =>
  withSystem({defaultValue, hiddenProperty: true, private: true}, TBoolean);

/** Whether a component field is a click goal tracking prop */
export const isClickGoalTrackingField = (
  field: Type | undefined
): field is Type => {
  const system = field ? getSystem(field) : null;
  return Boolean(system?.hiddenProperty && system?.private);
};

export const EVENT_IDS_ATOM_FIELD = withSystem(
  {private: true},
  TList(TRecord({name: TText, value: TBoolean}))
);

export const STYLE_OPTIMIZATION_DATA_ATTR_PREFIX = 'data-wf-style-experience-';

export const TEMPORARY_EXPERIENCE_ID = 'temporary_experience';
